import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import Headers from "../components/Headers";

const Categories = () => {
  const { categorys } = useSelector((state) => state.home);
  return (
    <div className="w-full bg-[whitesmoke]">
      <Headers />
      <div className="w-[95%] lg:w-[90%] mx-auto bg-[whitesmoke]">
        <div className="w-full flex items-center justify-center gap-3 md-lg:gap-8">
          <div className="w-[90%] h-[100dvh] ">
            <div className="relative ">
              <div className="overflow-hidden transition-all rounded-[20px] duration-500 absolute z-[9] w-full h-[83vh] mb-10 ">
                <h2 className=" text-[#212730] px-[3px] pt-[20px] pb-[10px] font-semibold text-lg">
                  Categories
                </h2>
                <ul className="py-2 text-slate-600 transition-all duration-500 font-medium h-full overflow-auto sm:pb-[20%] md:pb-[10%] sm-hide-scrollbar">
                  {categorys.map((c, i) => (
                    <Link
                      to={`/products?category=${c.name}`}
                      key={i}
                      className="flex justify-between items-center bg-white mb-4 rounded-[10px] gap-2 px-[24px] py-[6px] hover:bg-green-100 hover:font-semibold hover:text-secondary"
                    >
                      <div className="flex justify-start items-center gap-2 ">
                        <img
                          src={c.image}
                          className="w-[50px] h-[50px] rounded-full overflow-hidden"
                          alt={c.name}
                        />
                        <p className="text-md block ">{c.name}</p>
                      </div>
                      <IoIosArrowForward />
                    </Link>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Categories;
